import React, {useEffect, useState} from 'react';
import t from '../../../helpers/t';
import {Biscuit, Notification} from "../../../../utils";
import { setAppLogo } from '../../../../App';
import {
    clientLogoActions, useSelector
} from "inbooma-api";
import ImageUpload from "../../../components/ImageUpload";
import {getApiHost} from "../../../../Sync";
import * as FileSaver from "../../../../../vendor/FileSaver";

const MyInboomaView = (props) => {
    const {dispatch} = props;
    const [initialized, setInitialized] = useState(false);
    const _client_logos = useSelector(state => state['client_logos_data'].getClientLogos);
    const _client_logo_edit = useSelector(state => state['client_logos_data'].editClientLogo);
    const _client_logo_add = useSelector(state => state['client_logos_data'].addClientLogo);
    const [clientLogosPending, setClientLogosPending] = useState(false);
    const [clientLogoPending, setClientLogoPending] = useState(false);
    const [clientLogo, setClientLogo] = useState(null);
    const [image,setImage] = useState('');

    useEffect(() => {
        if (clientLogosPending === false || _client_logos.success === "") {
            return;
        }
        if(_client_logos.success === true){
            if(typeof _client_logos?.data !== 'undefined' && _client_logos?.data?.length > 0){
                setClientLogo(_client_logos.data[0]);
                //setImage(_client_logos.data[0].logo);
            }
        }
        setClientLogoPending(false);
        setClientLogosPending(true);
        setInitialized(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_client_logos]);

    useEffect(() => {
        if (clientLogoPending === false || _client_logo_add.success === "") {
            return;
        }
        if(_client_logo_add.success === true){
            showNotification('success',t('saved_${a}', {a: t('image')}, 'capital'))
        } else {
            showNotification('warning',null, _client_logo_add.data.message);
        }
        setClientLogoPending(false);

       setClientLogosPending(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_client_logo_add]);


    useEffect(() => {
        if (clientLogoPending === false || _client_logo_edit.success === "") {
            return;
        }
        if(_client_logo_edit.success === true){
            showNotification('success',t('saved_${a}', {a: t('image')}, 'capital'))
        } else {
            showNotification('warning',null, _client_logo_edit.data.message);
        }
        setClientLogoPending(false);
        setClientLogosPending(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_client_logo_edit]);

    useEffect(() => {
        if (!initialized) {
            dispatch(clientLogoActions.getClientLogos({
                token: Biscuit.get('token'),
                filter: {
                    client_id: Biscuit.get('user.client_id'),
                    type: 'main',
                    sort: 'id',
                    direction: 'desc'
                }
            }));
            setClientLogosPending(true);
        }
    }, [])

    useEffect(() => {
        if(image === '') return;
        onChangeImage(null, image);
    }, [image])

    const showNotification = (msgType, message,apiMsg) => {
        // little delay necessary to make notifications visible (render of background must be done before)
        setTimeout(() => {
            if (msgType === 'success') {
                new Notification({
                    message: message,
                    duration: 5000,
                    type: 'success',
                    closeable: true,
                    icon: 'fi fi-check'
                });
            } else if (msgType === 'warning') {
                new Notification({
                    message: (typeof apiMsg !== 'undefined' && apiMsg !== null) ? t(apiMsg, null, 'capital') : t('request_error', null, 'capital'),
                    duration: 5000,
                    type: 'warning',
                    closeable: true,
                    icon: 'fi fi-x'
                });
            }

        }, 200);

    };
    const getShorts = () => {
        let shorts = "";
        if (Biscuit.get('user.first_name') !== null) {
            shorts = Biscuit.get('user.first_name').charAt(0);
        }
        if (Biscuit.get('user.last_name') !== null) {
            shorts += Biscuit.get('user.last_name').charAt(0);
        }
        return shorts;
    }

    const getName = () => {
        let name;
        if (Biscuit.get('user.title') === null || Biscuit.get('user.title') === '' || Biscuit.get('user.title') === 'mx.')  {
           name = Biscuit.get('user.first_name') + ' ' + Biscuit.get('user.last_name');
        } else {
           name = t('user_title_' + (Biscuit.get('user.title').replace('.',''))) + ' ' + Biscuit.get('user.first_name') + ' ' + Biscuit.get('user.last_name');
        }
        return name;
    }

    const getUsernameAndRole = () => {
        return Biscuit.get('user.username') + ' (' + t('user_role',null,'capital') + ':' + t('role_' + Biscuit.get('user.role'))+')';
    }

    const getPrivacyURL = () => {
        return window.location.protocol + '//' + window.location.hostname + '/privacy.html?hash=' + Biscuit.get('client.hash') + '&lang=' + Biscuit.get('user.lang');
    }

    console.log('Biscuit User',Biscuit.get('user.user_address.phone_number'));

    const getRegisterURL = () => {
        const frontend_url = Biscuit.get('client.frontend_url');
        let first_url_part = 'https://general-frontend.inbooma.net/';
        let api_url = 'https://api.inbooma.net/api/';
        if (document.location.host.toLowerCase().indexOf('test-web.inbooma.net') >= 0) {
            first_url_part = 'https://test-general-frontend.inbooma.net/';
            api_url = 'https://test-api.inbooma.net/api/';
        }else if(document.location.host.toLowerCase().indexOf('staging-web.inbooma.net') >= 0) {
            first_url_part = 'https://staging-general-frontend.inbooma.net/';
            api_url = 'https://staging-api.inbooma.net/api/';
        }
        let startUrl = "&startPage=register";
        let url = "&i18n.lng=" + Biscuit.get('user.lang').replace('_','-') + "#/";
        let setFURL = false;
        if(frontend_url !== null && frontend_url !== ''&& frontend_url !== 'null'){
            url = frontend_url;
            setFURL=true;
        }
        startUrl += url;
        if(setFURL){
            startUrl += "&i18n.lng=" + Biscuit.get('user.lang').replace('_','-') + "#/";
        }
        return first_url_part + '?hash='+Biscuit.get('client.hash') + startUrl + 'register';
    }

    const onChangeImage = (e, logo = null) => {
        let img;
        if(logo === null) {
            img = e.target.value;
        } else {
            img = logo;
        }
        Biscuit.set('client.logo',img);
        setAppLogo(img);
        if(clientLogo !== null){
            // edit
            dispatch(clientLogoActions.editClientLogo({
                token: Biscuit.get('token'),
                id: clientLogo.id,
                body: {
                    logo: img
                }
            }));
        } else {
            dispatch(clientLogoActions.addClientLogo({
                token: Biscuit.get('token'),
                body: {
                    client_id: Biscuit.get('user.client_id'),
                    logo: img,
                    type: 'main'
                }
            }));
        }
        setClientLogoPending(true);
        setImage(img);
    }

    const onGetQRCodeHandler = (resourceId) => {

        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", getApiHost() + '/resources/getQRCode/'+resourceId+'/client',true);

        xmlHttp.setRequestHeader('Accept', 'application/json');
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.responseType = 'blob';

        xmlHttp.onerror = function () {

        };

        xmlHttp.onload = function () {
            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
                showNotification('warning',resourceId,message);
                return;
            }

            if (xmlHttp.status === 404 || typeof xmlHttp.response.size !== 'undefined' && xmlHttp.response.size === 13) {
                showNotification('warning',resourceId,message);
                return;
            }

            const blob = new Blob([xmlHttp.response], {type: 'image/png'});

            // Unfortunately, xmlHttp.getResponseHeader('Content-Disposition');
            // is null, so we have to
            // re-create the file name
            FileSaver.saveAs(blob, Biscuit.get('client.user_hash') + '.png');

        };

        xmlHttp.send(null);
    };

    return (
        <>
            <div id="inb-c-main" className="columns" style={{marginLeft:0,width:"100%"}}>

                <div id="inb-c-main-access-bar" className="clearfix"><h1
                    className="inb-page-title show-for-small-only"> {t('my_inbooma')} </h1>
                    <ul className="inb-hor-icon-nav float-left  hide-for-medium-only hide-for-small-only ac">
                        <li data-inb-val="overview" title="Übersicht-Ansicht öffnen." className="hide active"><a
                            href="/my-inbooma"> <i style={{verticalAlign: "middle"}} className="fi fi-list"></i>
                            <div style={{verticalAlign: "text-top",display: "inline"}}><span> {t('overview')} </span></div>
                        </a></li>
                    </ul>
                </div>

                <div className="off-canvas-wrapper column">
                    <div id="inb-c-main-my-inbooma"><br/>
                        <div className="inb-overview-user column medium-4 float-left"
                             style={{width:"100%",marginTop:"50px",textAlign:"center"}}>
                            <div className="vcard-wrapper inb-c-item">
                                <div className="row inb-vcard">
                                    <div className="inb-user-badge inb-user-badge--large"
                                         style={{position: "relative", width: "84px", marginTop: "-48px", marginLeft: "39%", backgroundImage: "url('"+Biscuit.get('client.logo')+"')"}}>{getShorts()}
                                    </div>
                                    <hr/>
                                        <div className="medium-12 column text-center"><h5
                                            className="inb-vcard--fullname">{getName()}</h5> <p
                                            className="inb-vcard--username"><i className="fi fi-torso"></i>{getUsernameAndRole()}</p> <p className="inb-vcard--email"><i
                                            className="fi fi-mail"></i>{Biscuit.get('user.email')}</p>  <p
                                            className="inb-vcard--phone"><i
                                            className="fi fi-telephone"></i>{Biscuit.get('user.user_address.phone_number') !== null ? Biscuit.get('user.user_addresses[0].phone_number') : ''}</p></div>
                                </div>
                            </div>
                            <div className="ienb-button-group" style={{margin:"0 1rem"}}><a
                                className="button medium beautify round hide" style={{minWidth: "415px"}} href="client/ics">{t('create_ics_all_orders', null, 'capital')} </a>
                                <a id="link_data_protection_agreement"
                                                                          className="button medium beautify round"
                                                                          style={{minWidth: "415px"}}
                                                                          href={getPrivacyURL()}
                                                                          rel="noopener noreferrer"
                                                                          target="_blank"> {t('data_protection_agreement')} </a>
                                <a id="link_user_register_page" className="button medium beautify round"
                                   style={{minWidth: "415px"}}
                                   href={getRegisterURL()}
                                   rel="noopener noreferrer" target="_blank">{t('user_register_page')}</a>
                            </div>
                            <div><span>{"Client-ID: "+Biscuit.get('user.client_id')}</span></div>
                         <div><span>{"Registrierungscode: "+Biscuit.get('client.user_hash')}</span></div>
                            <a id="link_register_qr_code" className="button medium beautify round"
                               style={{minWidth: "415px",marginTop:"10px"}}
                               href="#"
                               onClick={() => onGetQRCodeHandler(Biscuit.get('user.client_id'))}>{t('user_register_qr_code')}</a>
                            <div style={{padding: "16px",paddingTop: "20px"}}><span>Client-Logo:</span>
                                {/*<div></div>
                                <div id="client-logo-input" className="" type="file">
                                    <div><img id="client-logo-image" style={{maxWidth: "300px",maxHeight: "200px"}}
                                              src={Biscuit.get('client.logo')}/>
                                    </div>
                                    <label htmlFor="client-logo-input">
                                        <a id="logo_upload_btn">
                                            <i className="fi fi-page-add client-logo"> </i>
                                            {"+ "+t('edit_${a}',{a:t('image')})}
                                        </a>
                                    </label>
                                </div>*/}
                                {initialized &&
                                    <ImageUpload
                                    onChange={onChangeImage}
                                    image={image}
                                    showPreviewLabel={false}
                                    type='main'
                                    showInput={false}
                                    addButtonDirection="down"
                                    addButtonText={"+ "+t('edit_${a}',{a:t('image')})}
                                    clientId={Biscuit.get('user.client_id')}
                                    setImage={setImage}
                                    imageStyle={{maxWidth: "300px",maxHeight: "200px"}}
                                    portImage={true}
                                    dispatch={dispatch}
                                />}
                            </div>
                        </div>
                        <div className="hide inb-booking-activity inb-c-item float-right medium-7 column">
                            <h4>{t('booking_activity')}</h4>
                            <ul className="inb-tabs">
                                <li className="tabs-title small-3 medium-2 is-active" data-inb-val="180"><a href="#"
                                                                                                            aria-selected="true"> {t('${a}_days', { a: '365' })}</a></li>
                                <li className="tabs-title small-3 medium-2" data-inb-val="90"><a href="#"> {t('${a}_days', { a : '180' })} </a>
                                </li>
                                <li className="tabs-title small-3 medium-2" data-inb-val="30"><a href="#"> {t('${a}_days', { a : '90' })} </a>
                                </li>
                            </ul>
                            <canvas id="myChart" width="400" height="180" style={{marginTop:"18px",display:"none"}}></canvas>
                        </div></div>
                </div>

            </div>
        </>
  );
}

export default MyInboomaView;